var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-row",on:{"click":_vm.goToRoute}},[_c('font-awesome-icon',{staticClass:"sliderIcon",attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"detailtitle"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.value))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }